import { useIsSecuritySunsetEnabled } from 'features/organization/security-insights/hooks/useIsSecuritySunsetEnabled';
import { FEATURE_TO_TITLE } from 'hooks/dialogs/cluster/constants';
import { FeatureName } from 'hooks/dialogs/cluster/types';

import { ConnectionProgressItem } from '../../../../../_components/new-onboarding';
import { useAssignCredentialsDialogV2Context } from '../../context';

export const useFeatureProgressItems = (): ConnectionProgressItem[] => {
  const isSecuritySunsetEnabled = useIsSecuritySunsetEnabled();
  const {
    featureSelection,
    featureEnablementStatus,
    alreadyInstalledFeatures,
  } = useAssignCredentialsDialogV2Context();

  const items: ConnectionProgressItem[] = [];

  for (const [feature, selected] of Object.entries(featureSelection) as [
    FeatureName,
    boolean
  ][]) {
    if (!selected) continue;
    if (feature === 'security' && isSecuritySunsetEnabled) continue;
    if (alreadyInstalledFeatures[feature]) continue;

    items.push({
      key: feature,
      label: FEATURE_TO_TITLE[feature],
      status:
        featureEnablementStatus[feature] === true ? 'completed' : 'in_progress',
    });
  }

  return items;
};
